import { render } from "./ZoomControl.vue?vue&type=template&id=ebc05af2&scoped=true"
import script from "./ZoomControl.vue?vue&type=script&lang=js"
export * from "./ZoomControl.vue?vue&type=script&lang=js"

import "./ZoomControl.vue?vue&type=style&index=0&id=ebc05af2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebc05af2"]])

export default __exports__